
import PageTitle from '@/components/shared/PageTitle/index.vue'
import InformationFormOne from '~/components/Base/InformationForms/InformationFormOne/index.vue'
import defaultAsyncData from '~/mixins/defaultAsyncData';
export default {
  components: {
    PageTitle,
    InformationFormOne
  },
  mixins: [defaultAsyncData]
}
